import { render } from "./header.vue?vue&type=template&id=9132fef6&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=9132fef6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9132fef6"

export default script